import { Popover } from '@heathmont/moon-core-tw';
import MobileToggle from './MobileToggle';
import ClappsTooltipBody from '../ClappsTooltip/ClappsTooltipBody';
import useTooltipState from '../useClappsToggle/useTooltipState';

const MobileClappsToggle: FC = () => {
  const { messageId, showTooltip } = useTooltipState();

  return (
    <Popover position="bottom-start">
      <Popover.Trigger>
        <MobileToggle showTooltip={showTooltip} />
      </Popover.Trigger>
      {messageId !== null && (
        <Popover.Panel className="z-5 w-72 divide-solid rounded border-none p-6 text-bulma">
          <ClappsTooltipBody messageId={messageId} />
        </Popover.Panel>
      )}
    </Popover>
  );
};

export default MobileClappsToggle;
